export default __webpack_public_path__ + "static/media/1075.60da3c43.png";